import { initCar } from '../constants/formConfig';
import { RG, Inp, Sel, Btn } from './ui/FormControls';

export const CarretillaForm = ({ car, setCar, equipos, guardar }) => (
  <div className="bg-white rounded-xl shadow p-4 space-y-4">
    <h2 className="font-bold text-gray-800 border-b pb-2">🏗️ Revisión Carretilla</h2>
    <Inp label="Nombre y Apellidos *" value={car.nombre} onChange={v => setCar(s => ({ ...s, nombre: v }))} placeholder="Nombre completo" />
    <Sel label="Indica la Carretilla *" value={car.equipo} onChange={v => setCar(s => ({ ...s, equipo: v }))} options={equipos.filter(e => e.Activo && ["CE-","CR-","PP-","PPF-"].some(p => e.Nombre.startsWith(p))).map(e => e.Nombre)} />
    <div className="border rounded-lg overflow-hidden">
      <div className="bg-blue-50 px-3 py-2"><p className="text-xs font-bold text-blue-800 uppercase">📋 Check List</p></div>
      <div className="divide-y">{Object.entries(car.items).map(([k, { v, n, o }], i) => (
        <div key={k} className="px-3 py-3">
          <div className="flex items-start justify-between gap-2">
            <div className="flex-1"><p className="text-sm font-semibold text-gray-800">{i + 1}. {k}</p>{n && <p className="text-xs text-gray-400 mt-0.5">{n}</p>}</div>
            <RG value={v} onChange={val => setCar(s => ({ ...s, items: { ...s.items, [k]: { ...s.items[k], v: val } } }))} opts={o} />
          </div>
        </div>
      ))}</div>
    </div>
    <div><label className="text-xs font-semibold text-gray-600 uppercase">Comentarios</label><textarea className="w-full border rounded-lg px-3 py-2 text-sm mt-1 focus:outline-none focus:ring-2 focus:ring-blue-400" rows={3} value={car.observaciones} onChange={e => setCar(s => ({ ...s, observaciones: e.target.value }))} /></div>
    <Btn onClick={() => { guardar("Carretilla", car); setCar(initCar()); }} disabled={!car.nombre || !car.equipo}>Enviar para validación →</Btn>
  </div>
);
